<template>
  <FlexLayout col>
    <SectionTitle
      hideBtn
      :tooltip="$t('member.tab.point.balanceDetailTip')"
    >
      <SVGIcon :icon="isOrgPoint ? 'common-org_icon' : 'common-shop_icon'" stroke="var(--gray-80)" fill="transparent" width="20" height="20" />
      {{ $t('member.tab.point.balanceDetail') }}
    </SectionTitle>
    <BaseTable v-loading="loading" :data="displayTableData">
      <BaseElTableColumn prop="expirationDate" :label="$t('member.tab.point.expiryDate')" align="center" />
      <BaseElTableColumn prop="totalRemaining" :label="$t('member.tab.point.remainingPoints')" align="center" />
    </BaseTable>
  </FlexLayout>
</template>

<script>
import { FindMemberPointActiveDetails } from '@/api/shopPoint'
import { computed, defineComponent, inject, onMounted, ref } from 'vue'
import { map } from 'lodash'
import store from '@/store'
import { useTable } from '@/use/table'
import { useOrgBenefitControl } from '@/use/useOrgBenefitControl'

export default defineComponent({
  name: 'PointBalanceDetail',
  props: {
    memberId: {
      type: String,
    },
    shopPointKey: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const { dateFormat } = useTable()
    const { enableOrgBenefitSharing } = useOrgBenefitControl()
    const pageShopPoint = inject('pageShopPoint')
    const isOrgPoint = computed(() => enableOrgBenefitSharing.value && pageShopPoint?.value?.sourceShopIsHeadquarter)
    const shopId = computed(() => store.getters.shop)
    const loading = ref(false)
    const tableData = ref([])

    const displayTableData = computed(() => {
      return map(tableData.value, (item) => ({
        ...item,
        expirationDate: item.expirationDate ? dateFormat(item.expirationDate, 'YYYY/MM/DD') : '-',
      }))
    })

    const refresh = async () => {
      loading.value = true
      const [res, err] = await FindMemberPointActiveDetails({
        shopId: shopId.value,
        memberId: props.memberId,
        shopPointKey: props.shopPointKey,
      })
      if (err) {
        window.$message.error(err)
        loading.value = false
        return
      }
      tableData.value = res.items || []
      loading.value = false
    }

    onMounted(refresh)

    return {
      loading,
      displayTableData,
      isOrgPoint,
      refresh,
    }
  },
})
</script>
